/**
 * Copy e endereco da secao que funde "Guia Estatistico" e "Analise de Progresso"
 * (spec r6/29, R5).
 *
 * O NOME AQUI E PROVISORIO. A r6-29 depende da r6-27 (glossario) apenas para nomear:
 * enquanto Pereira nao documenta o significado de cada metrica, a secao se chama
 * "Analise Estatistica". Quando o glossario sair, a r6-26/r6-27 trocam as strings
 * DESTE arquivo e nada mais — menu, h1 da pagina, rotulos das abas e testes leem daqui.
 *
 * O que NAO vive aqui e NAO muda: "Analise de Metricas" (`/app/analise-metricas`, a tela
 * das 4 abas) continua sendo outra tela, com outro nome, fora desta fusao (decisao §4.3).
 *
 * Os rotulos das abas continuam sendo os nomes que o aluno ja conhece: quem tinha
 * bookmark de uma das duas telas precisa reconhecer para onde o redirect o levou.
 *
 * Sem barrel `index.ts` nesta pasta, de proposito: `manual.ts` (r6-28) e `objective.ts`
 * (r6-30) nasceram na mesma leva, e um barrel seria a linha que tres tasks reescrevem.
 */
export const ANALYSIS_SECTION = {
  /** Nome da secao unificada — provisorio ate a r6-27. */
  label: 'Análise Estatística',
  /** Endereco unico das duas leituras (§4.1). O aluno le a URL: ela acompanha o nome. */
  path: '/app/analise-estatistica',
  /** Subtitulo da pagina: as duas leituras numa frase. */
  description:
    'O que suas bancas cobram, onde você está nisso e quanto do conteúdo delas você já registrou.',
  /** Rotulos das duas abas, na ordem em que aparecem. */
  tabs: {
    progress: 'Análise de Progresso',
    guide: 'Guia Estatístico',
  },
} as const

/** Enderecos antigos, vivos por redirect com query preservada (R1). Nao use em link novo. */
export const ANALYSIS_LEGACY_ROUTES = {
  guide: '/app/guia-estatistico',
  progress: '/app/analise-progresso',
} as const

/** Prefixo do layout autenticado — `path: '/app'` em `routes/index.tsx`. */
export const ANALYSIS_APP_BASE = '/app'

/**
 * Deriva o segmento RELATIVO que o react-router espera na rota filha de `/app`.
 *
 * Falha alto e cedo, no import: o unico jeito de a excecao subir e alguem trocar um dos
 * paths acima por algo fora de `/app`, e nesse caso o silencio custaria mais — o link
 * cairia no catch-all com tsc, eslint e a suite inteira verdes.
 */
function toAppRouteSegment(path: string): string {
  const prefix = `${ANALYSIS_APP_BASE}/`

  if (!path.startsWith(prefix) || path === prefix) {
    throw new Error(`Rota da secao de analise fora de ${ANALYSIS_APP_BASE}: "${path}"`)
  }

  return path.slice(prefix.length)
}

/**
 * Os mesmos tres enderecos, na grafia que `routes/index.tsx` usa (r6-29, correcao
 * pos-revisao).
 *
 * As filhas de `/app` sao declaradas com path RELATIVO, entao o literal
 * `path: 'analise-estatistica'` era uma segunda grafia do caminho canonico, sem tipo nem
 * teste ligando as duas: trocar o nome da secao continuava sendo num arquivo so, mas
 * trocar o CAMINHO exigia lembrar do router. Derivando aqui, volta a ser num arquivo so.
 */
export const ANALYSIS_ROUTE_SEGMENTS = {
  section: toAppRouteSegment(ANALYSIS_SECTION.path),
  guide: toAppRouteSegment(ANALYSIS_LEGACY_ROUTES.guide),
  progress: toAppRouteSegment(ANALYSIS_LEGACY_ROUTES.progress),
} as const
